import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { Form } from 'react-form';
import async from 'async';
import { injectIntl } from 'react-intl';
import _ from 'lodash';
import Translate from 'translate';

import ServiceService from 'services/ServiceService'
import ChannelService from 'services/ChannelService'
import CategoryService from 'services/CategoryService'
import { FormGroup, Checkbox, Select, Textarea, Text } from 'components/FormElements';
import { toggleAlertError, toggleLoading } from 'stores/actions';

class ChangeStatusModal extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {};

    this.submitForm = this.submitForm.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if ( nextProps.open && !this.props.open && nextProps.data.status === 'open' ) {
      this.getData()
    }
  }

  getData() {
    this.props.toggleLoading( true );

    async.parallel( {
      categories: this.getCategories,
      services: this.getServices
    }, ( error, results ) => {
      this.props.toggleLoading( false );

      if ( !error ) {
        this.setState( results )
      }
    } )
  }

  getCategories( cb ) {
    CategoryService.getCategories( { 'filters[active]': 1, limit:-1} )
      .then( ( response ) => cb( response.errors, response.data ? response.data.data : [] ) );
  }

  getServices( cb ) {
    ServiceService.getServices( { 'filters[active]': 1 } ).then( ( response ) => {
      if ( response.errors ) return cb( response.errors );
      return cb( null, response.data.data )
    } )
  }

  submitForm( formData ) {
    const { channel, data, onClose, onReloadData, onReloadClosedChannel, onReloadChannel, toggleAlertError, toggleLoading, intl, externalCustomer } = this.props;

    toggleLoading( true );

    formData.status = data.status;

    if ( externalCustomer === 'apu' && data.status === 'open' ){
      formData.notShare = true;
    }

    ChannelService.updateChannelStatus( channel.id, {
      ...formData,
      categories: _.map( formData.categories, 'id' ),
    } ).then( ( response ) => {
      toggleLoading( false );
      
      if ( response.errors )  {

        if (response.status === 400){
          onReloadClosedChannel( channel.id );
        }
        return toggleAlertError( intl.formatMessage( { id: response.errors } ) );
      } 

      if( data.status === 'closed' )
        onReloadClosedChannel( channel.id );
       else if( channel.status === 'closed' && data.status === 'open' ) {
        onReloadChannel( channel.id );
      }
      else onReloadData( channel.id );
      onClose()
    } )
  }

  render() {
    const { data, onClose, open, tones, type, intl } = this.props;
    const highTone = _.find( tones, { tone: 'HIGH', active: true } );
    const lowTone = _.find( tones, { tone: 'LOW', active: true } );
    const neutralTone = _.find( tones, { tone: 'NEUTRAL', active: true } );

    return (
      <Modal closeOnEsc={false}
             little
             modalClassName="col-md-6"
             open={open}
             onClose={onClose}>
        <h5 className="mt-0"><Translate id="changeStatus"/>: {data.status}</h5>

        <Form onSubmit={this.submitForm}
        validate={values => {
          const errors = {};
          if(data.status === 'open' && !values.service)errors.service =  intl.formatMessage({id:"fieldError.required"});
          if(data.status === 'open' && (!values.categories || values.categories.length < 1))errors.categories =  intl.formatMessage({id:"fieldError.required"});
          if(!values.lastComment)errors.lastComment = intl.formatMessage({id:"fieldError.required"});
          return errors;
        }}
        >
          {( { getValue, setValue, submitForm } ) =>
            <form onSubmit={submitForm}>
              {data.status === 'open' &&
              <div>
                <div className="row">
                  <FormGroup containerClass="col-md-6">
                    <Checkbox field="important" label={<Translate id="markAsImportant"/>}
                              labelPosition="right"
                              labelStyle={{ width: 'auto' }}/>
                  </FormGroup>

                  <div className="col-md-6 color-info">
                    {!!highTone &&
                    <img onClick={() => setValue( 'tone', highTone.id )} width={26}
                         src={getValue( 'tone' ) === highTone.id ? 'assets/images/icons/thumb-up.png' : 'assets/images/icons/thumb-up-o.png'}/>
                    }
                    {!!neutralTone &&
                    <img className="mx-2" onClick={() => setValue( 'tone', neutralTone.id )} width={28}
                         src={getValue( 'tone' ) === neutralTone.id ? 'assets/images/icons/point-at.png' : 'assets/images/icons/point-at-o.png'}/>
                    }
                    {!!lowTone &&
                    <img onClick={() => setValue( 'tone', lowTone.id )} width={26}
                         src={getValue( 'tone' ) === lowTone.id ? 'assets/images/icons/thumb-down.png' : 'assets/images/icons/thumb-down-o.png'}/>
                    }
                  </div>
                </div>

                <FormGroup>
                  <label><Translate id="service"/></label>
                  <Select field="service" className="form-control"
                          placeholder={intl.formatMessage( { id: "selectService" } )}
                          labelKey="service" options={this.state.services}/>
                </FormGroup>

                <FormGroup>
                  <label><Translate id="categories"/></label>
                  <Select field="categories" className="form-control"
                          placeholder={intl.formatMessage( { id: "selectCategories" } )}
                          labelKey="category" simpleValue={false} multi
                          options={this.state.categories}/>
                </FormGroup>
              </div>
              }

              {type === 'chat' &&
              <FormGroup>
                <Checkbox field="sendChat" label={<Translate id="sendAsChat"/>}
                          labelPosition="right"
                          labelStyle={{ width: 'auto' }}/>
              </FormGroup>
              }

              <FormGroup>
                <label><Translate id="comment"/></label>
                <Textarea field="lastComment" className="form-control" rows={5}/>
              </FormGroup>
              
              <div className="text-right">
                <button className="btn btn-outline-secondary mr-2" type="button" onClick={onClose}>
                  Cancel
                </button>
                <button className="btn btn-info"><Translate id="submit"/></button>
              </div>
            </form>
          }
        </Form>
      </Modal>
    )
  }
}

const mapStateToProps = ( state ) => ({
  externalCustomer: state.settings.externalCustomer,
});

const mapDispatchToProps = dispatch => ({
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( injectIntl( ChangeStatusModal ) );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/ChangeStatusModal/index.js